import { PublicPurchaseService } from './purchase';
export class PublicPurchaseServiceMock extends PublicPurchaseService {
    constructor() {
        super(...arguments);
        this.mockedData = {};
    }
    cancelOrder(channelId, siteUrl, instance) {
        return Promise.resolve(undefined);
    }
    createOrder(videoId, channelId, paymentType, siteUrl, instance, compId) {
        return Promise.resolve(this.mockedData.createOrder);
    }
    getPaymentStatus(videoId, channelId, orderId, transactionId, instance, paymentType) {
        // todo: what the actual?
        return Promise.resolve(undefined);
    }
    reset() {
        this.mockedData = {};
    }
    mockCreateOrder(orderId) {
        this.mockedData.createOrder = orderId;
    }
}
export const publicPurchaseServiceMock = new PublicPurchaseServiceMock();
export function createPublicPurchaseService() {
    return publicPurchaseServiceMock;
}
//# sourceMappingURL=purchase.mock.js.map